import { collection, getDocs, query, where, orderBy } from "firebase/firestore";
import { db } from "../firebaseConfig";

const JOBS_COLLECTION = "ats_jobs";

export const getJobs = async (companyId) => {
  try {
    const jobsQuery = query(
      collection(db, JOBS_COLLECTION),
      where("companyId", "==", companyId),
      where("status", "==", "Published"), // 🔥 NEW FILTER
      orderBy("title")
    );

    const snapshot = await getDocs(jobsQuery);

    const jobs = snapshot.docs.map((doc) => {
      const data = doc.data();

      console.log("FULL DATA:", data);

      return {
        id: doc.id,
        title: data.title || data.jobTitle || "Untitled Role",
        location: data.location || data.city || "Location not provided",
        exp: data.experienceText || "Experience not provided",
        code: data.code || data.jobCode || doc.id,
        ...data,
      };
    });

    return jobs;
  } catch (error) {
    console.error("Error fetching jobs:", error);
    throw error;
  }
};

export { JOBS_COLLECTION };